module.exports = __webpack_public_path__ + "img/13.de3cd4cd.png";